import microwebRegisterWebComp, {} from '@helsenorge/microweb/register';
import { error } from '../logger';
function registerWebComp(ChildComponent, config) {
    microwebRegisterWebComp(ChildComponent, { onError: error, ...config });
}
export default registerWebComp;
